module["exports"] = [
  "?#? #?#"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_IND/address/postcode.js
// module id = 1036
// module chunks = 0